<template>
  <div class="grid grid-cols-2 gap-6">
    <div class="grid grid-cols-2 gap-6">
      <NetSelect></NetSelect>
      <UiInput
        label="PASS Contract Type "
        modelValue="ERC1155"
        readonly
      ></UiInput>
    </div>

    <UiDropdown
      label="Collateral Token"
      v-model="state.token"
      :options="options"
      class="w-2/5"
      boxStyle="drop-height"
    ></UiDropdown>
  </div>

  <div class="grid grid-cols-2 gap-6">
    <div class="grid grid-cols-2 gap-6">
      <UiInput
        ref="input1"
        label="Creator Fee"
        required
        v-model="formInfo.passBondingCurve.creatorFee"
        endTag="%"
        :maxValue="20"
        typeMode="INT"
        :rules="['gtZero']"
        placeholder="No more than 20%"
        showError
      ></UiInput>
      <UiInput
        label="Platform Commission"
        readonly
        :modelValue="formInfo.passBondingCurve.platformCommission"
        endTag="%"
      ></UiInput>
    </div>
    <UiInput
      v-model="formInfo.passBondingCurve.receivingAddress"
      ref="input2"
      label="Receiving address"
      required
      placeholder="Please enter your address"
      :rules="['address']"
      showError
    ></UiInput>
  </div>

  <div class="text-whitebase space-y-4">
    <div
      class="rounded p-2 space-x-2 flex bg-white-005 my-3"
      style="width: fit-content"
    >
      <div
        class="
          px-6
          rounded
          flex
          items-center
          h-10
          transition-all
          cursor-pointer
          font-bold
        "
        v-for="(text, i) in ['Basic', 'Adv']"
        :style="`background:${
          i == state.mode
            ? 'linear-gradient(315deg, #FF5585 0%, #268CFF 100%);'
            : ''
        }`"
        @click="state.mode = i"
        :key="i"
      >
        {{ text }}
      </div>
    </div>

    <div class="space-x-5" v-if="state.mode == 0">
      <span>Formulas:</span> <span>y = 0.00002x^2 + v</span>
      <span>if x = 1,then v = initial price - 0.00002</span>
    </div>
    <div class="space-x-5" v-else>
      <span>Formulas:</span> <span>y = m*x^n + v</span>
      <span>if x = 1,then v = initial price - m</span>
    </div>

    <div class="grid grid-cols-2 gap-6">
      <UiInput
        label="Initial price"
        required
        :modelValue="
          state.mode == 0 ? state.config1.price : state.config2.price
        "
        @update:modelValue="onPrice"
        :endTag="state.token.label"
      ></UiInput>
    </div>

    <div class="flex" v-if="state.mode != 0">
      <UiInput
        endTag="m"
        class="w-2/5 mr-4 pr-2"
        v-model="state.config2.m"
      ></UiInput>
      <UiInput
        endTag="n"
        class="w-2/5 pr-2"
        v-model="state.config2.n"
      ></UiInput>
    </div>
    <div>
      For the whole list of price change according to supply, you can check it
    </div>

    <Chart
      :m="config.m"
      :n="config.n"
      :price="config.price"
      height="156"
    ></Chart>
  </div>
</template>

<script setup>
import Chart from '@/components/BondingCurveChart.vue';
import { getBcPaywithOptions } from '@/constants';
import { getBcPlatformFee } from '@/constants/contract/read';
import { useNetwork } from '@/hooks';
import {
  computed,
  inject,
  onMounted,
  reactive,
  ref,
  watch,
  watchEffect,
} from 'vue';
import UiDropdown from '../component/UiDropdown.vue';
import NetSelect from '../component/NetSelect.vue';
import UiInput from '../component/UiInput.vue';

const formInfo = inject('formInfo');
const checks = inject('checks');

const network = useNetwork();

const input1 = ref(null);
const input2 = ref(null);

const options = computed(() =>
  getBcPaywithOptions(network.value).map((x) => ({ label: x, value: x })),
);

const state = reactive({
  token: {
    label: 'USDT',
    value: '',
  },
  mode: 0,
  config1: {
    price: '',
    n: '2',
  },
  config2: {
    price: '',
    n: '2',
    m: '0.000001',
  },
});

const config = computed(() => {
  if (state.mode == 0) {
    return {
      n: '2',
      m: state.config1.price * 0.0000002,
      price: state.config1.price,
    };
  } else {
    return state.config2;
  }
});

const onPrice = (price) => {
  if (state.mode == 0) {
    state.config1.price = price;
  } else {
    state.config2.price = price;
  }
};

const checkForm = () => {
  let flag = true;

  if (
    input1.value.checkRule() ||
    input2.value.checkRule() ||
    (state.mode == 0 && !state.config1.price) ||
    (state.mode == 1 &&
      (!state.config2.price || !state.config2.n || !state.config2.m))
  ) {
    flag = false;
  }

  checks.checkBondingCurve = flag;
};

watchEffect(() => {
  formInfo.passBondingCurve.collateralTokens = state.token.label;

  formInfo.passBondingCurve.initialPrice = config.value.price;
  formInfo.passBondingCurve.m = config.value.m;
  formInfo.passBondingCurve.n = config.value.n;
});

watch(
  () => JSON.stringify(formInfo.passBondingCurve),
  () => {
    checkForm();
  },
);

onMounted(async () => {
  const x = await getBcPlatformFee(network.value);
  formInfo.passBondingCurve.platformCommission = x;
});
</script>

<style scoped>
:deep(.drop-height) {
  height: 56px;
}
</style>
